import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import {
  IonContent,
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react'
import RadioLatestCategorySwipper from '../../components/common/RadioLatestCategorySwipper'
import RadioCategorySwipper from './RadioCategorySwipper'
import RadioCategorySwipperSkeleton from './RadioCategorySwipperSkeleton'
import { setRadioMetaTags } from '../../services/metatags'
import { setView } from '../../services/analytics'
import { setPixelView } from '../../services/fbPixel'
import { getProducts } from '../../services/api/products'
import './styles.scss'

const RadioByCategory = props => {
  const [isVisible, setIsVisible] = useState(false)
  const [_category, setCategory] = useState(false)
  const [data, setData] = useState([])
  const contentRef = useRef()
  const { category } = useParams()
  const history = useHistory()

  useIonViewDidEnter(() => {
    setIsVisible(true)
    setView(window.location.pathname)
    setPixelView()
  })

  useIonViewWillLeave(() => {
    setIsVisible(false)
  })

  useEffect(() => {
    setRadioMetaTags()
    const params = {
      section: 'radio',
      category: category,
      includeContents: 1
    }
    getProducts(params)
      .then((response) => {
        setCategory(response[0])
      }).catch(() => {
        setCategory(false)
        history.push('/404')
      })
    return () => {
      setCategory(false)
    }
  }, [category])

  useEffect(() => {
    if (_category) {
      setRadioMetaTags({
        title: `Explora todos los programas de ${_category.category} de Yok Radio`
      })
      setData(_category.products)
    } else {
      setData([])
    }
  }, [_category])

  if (isVisible === false) return null

  return (
    <IonContent
      ref={contentRef}
      fullscreen
      className='radio-by-category-page page-wrapper'
    >

      <div className='center-wrapper'>

        <RadioLatestCategorySwipper section='radio' category={category} />

        {data.length === 0 &&
          <>
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
            <RadioCategorySwipperSkeleton />
          </>}

        {data.length > 0 &&
          <>
            {data.map((product) => (
              <RadioCategorySwipper
                key={product.id}
                product={product}
              />
            ))}
          </>}
      </div>
    </IonContent>
  )
}

export default RadioByCategory
